"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CATEGORIES_SECTION_SKELETON = void 0;
const CATEGORIES_SECTION_SKELETON = exports.CATEGORIES_SECTION_SKELETON = 'categories-section-skeleton';
